import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import { useRefinementList } from 'react-instantsearch';

/**
 * Wrapper for the legacy connectRefinementList HOC from react-instantsearch-dom v6.
 * This provides the same API but uses the v7 react-instantsearch hook internally.
 *
 * CRITICAL: hookParams must be memoized to prevent infinite re-render loops.
 * Only the valid hook parameters are extracted and their values used as dependencies.
 *
 * @param {Function} Component - A component that receives refinement list data as props
 * @returns {React.Component} - A wrapped component connected to InstantSearch refinement list
 */
export const connectRefinementList = Component => {
  const ConnectedComponent = props => {
    const $ = _c(12);
    const {
      attribute,
      operator,
      limit,
      showMore,
      showMoreLimit,
      sortBy,
      escapeFacetValues,
      transformItems
    } = props;
    let t0;
    if ($[0] !== attribute || $[1] !== escapeFacetValues || $[2] !== limit || $[3] !== operator || $[4] !== showMore || $[5] !== showMoreLimit || $[6] !== sortBy || $[7] !== transformItems) {
      t0 = {
        attribute,
        operator,
        limit,
        showMore,
        showMoreLimit,
        sortBy,
        escapeFacetValues,
        transformItems
      };
      $[0] = attribute;
      $[1] = escapeFacetValues;
      $[2] = limit;
      $[3] = operator;
      $[4] = showMore;
      $[5] = showMoreLimit;
      $[6] = sortBy;
      $[7] = transformItems;
      $[8] = t0;
    } else {
      t0 = $[8];
    }
    const hookParams = t0;
    const refinementListData = useRefinementList(hookParams);
    let t1;
    if ($[9] !== props || $[10] !== refinementListData) {
      t1 = <Component {...props} {...refinementListData} />;
      $[9] = props;
      $[10] = refinementListData;
      $[11] = t1;
    } else {
      t1 = $[11];
    }
    return t1;
  };
  ConnectedComponent.displayName = `connectRefinementList(${Component.displayName || Component.name || 'Component'})`;
  return ConnectedComponent;
};
export default connectRefinementList;